import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import type { ApiTypes } from '@hyundai/ng-common-lib';
import { DealerFeature, isSubDealer, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M010C020IconLinkComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-quick-links',
    standalone: true,
    imports: [M010C020IconLinkComponent, RouterLinkDirective, TrackingDirective],
    templateUrl: './quick-links.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickLinksComponent {
    store = inject(Store);

    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);

    dealer = input.required<ApiTypes.Dealer>();
    aboutUsUrl = computed(() => {
        const d = this.dealer();
        return isSubDealer(d) ? d.aboutUsUrl : d.pages.aboutUs;
    });
    contactLink = input.required<string>();
}
